/** The one side panel Appointment detail shows at a time; opening one closes the other. */
export type OpenPanel = "previous-notes" | "recap" | null;

/** Desktop opens Previous SOAP notes by default; below 1024px nothing opens on load. */
export function initialOpenPanel(isDesktop: boolean): OpenPanel {
  return isDesktop ? "previous-notes" : null;
}

export function toggleOpenPanel(
  current: OpenPanel,
  panel: Exclude<OpenPanel, null>
): OpenPanel {
  return current === panel ? null : panel;
}

/** A breakpoint flip resets to the load default; an open Recap closes, its chip remains. */
export function openPanelForBreakpoint(isDesktop: boolean): OpenPanel {
  return initialOpenPanel(isDesktop);
}

/** The Recap drawer cannot stay open once the Recap is absent. */
export function reconcileOpenPanel(
  current: OpenPanel,
  recapVisible: boolean
): OpenPanel {
  return current === "recap" && !recapVisible ? null : current;
}

/** The shell's siderail narrows while either docked drawer is open. */
export function shellSqueezed(isDesktop: boolean, open: OpenPanel): boolean {
  return isDesktop && open !== null;
}

/** Viewport width, in px, at which the Previous notes drawer may be widened. */
export const WIDEN_MIN_VIEWPORT = 1280;
export const DRAWER_WIDTH_DEFAULT = 400;
export const DRAWER_WIDTH_WIDE = 640;

/** Widen is offered only to the docked drawer, and only on a wide viewport. */
export function widenAvailable(isDesktop: boolean, isWideViewport: boolean): boolean {
  return isDesktop && isWideViewport;
}

/** 640px only while widened on a viewport that can afford it; otherwise 400px. */
export function previousNotesDrawerWidth(
  wide: boolean,
  isDesktop: boolean,
  isWideViewport: boolean
): typeof DRAWER_WIDTH_DEFAULT | typeof DRAWER_WIDTH_WIDE {
  return wide && widenAvailable(isDesktop, isWideViewport)
    ? DRAWER_WIDTH_WIDE
    : DRAWER_WIDTH_DEFAULT;
}
